import { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalServiceData } from './ModalServiceData';
import { ModalEditService } from '../../views/Calendar/components/ModalEditService';
import CancelServiceModal from '../../views/ServicesHistory/components/CancelServicesModal';
import { incidentSupportStates } from '../../config/constants/incidentsStatus';
import { ModalEditSupportService } from '../../views/ServicesHistory/components/modals/ModalEditSupportService';
import { solutionConstants } from '../../config/constants/solutionsConstants';

export function useModalServiceEvent({ onSaveData }) {
  const { solutionId } = useSelector((state) => ({
    solutionId: state.auth.accountData.solutionId,
  }));
  const accountsCanEdit = solutionId === solutionConstants.TAPPTUS.id || solutionConstants.MIEMERGENCIA.id
  const [selectedServiceData, setSelectedServiceData] = useState({
    showDetailsModal: false,
    showEditModal: false,
    showCancelModal: false,
    serviceId: null,
    serviceStatus: null,
    showEditSupportModal: false,
  });

  const handleEditService = (id) => () => {
    const status = selectedServiceData.serviceStatus
    if ((incidentSupportStates.includes(status)) && accountsCanEdit) {
      return setSelectedServiceData({
        showEditSupportModal: true,
        showDetailsModal: false,
        serviceId: id,
      })
    }
    setSelectedServiceData({
      showEditModal: true,
      serviceId: id,
    });
  };

  const onHanldeCloseModalEdit = () => {
    if (onSaveData) onSaveData();
    setSelectedServiceData({
      showEditModal: false,
      showEditSupportModal: false,
    });
  };

  const handleCancelService = (id) => () => {
    setSelectedServiceData({
      showCancelModal: true,
      serviceId: id,
    });
  };

  const closeModalCancel = (reloadEvents) => {
    if (reloadEvents) {
      if (onSaveData) onSaveData();
    }
    setSelectedServiceData({
      showCancelModal: false,
    });
  };

  const handleOpenModal = (id, status) => {
    setSelectedServiceData({ showDetailsModal: true, serviceId: id, serviceStatus: status });
  };

  const handleCloseModal = (refresh) => {
    if (refresh && onSaveData) onSaveData();

    setSelectedServiceData((current) => ({ ...current, showDetailsModal: false }));
  };

  return {
    selectedServiceData,
    handleEditService,
    onHanldeCloseModalEdit,
    handleCancelService,
    closeModalCancel,
    handleOpenModal,
    handleCloseModal,
  };
}

export function ModalServiceEvent({
  selectedServiceData,
  handleEditService,
  onHanldeCloseModalEdit,
  handleCancelService,
  closeModalCancel,
  handleCloseModal,
}) {
  return (
    <>
      {selectedServiceData?.showEditModal ? (
        <ModalEditService
          show={selectedServiceData?.showEditModal}
          serviceId={selectedServiceData.serviceId}
          handleClose={onHanldeCloseModalEdit}
        />
      ) : null}
      {
        selectedServiceData?.showEditSupportModal ? (
          <ModalEditSupportService
            show={selectedServiceData?.showEditSupportModal}
            serviceId={selectedServiceData.serviceId}
            handleClose={onHanldeCloseModalEdit}
          />
        ) : null
      }
      {selectedServiceData?.showCancelModal ? (
        <CancelServiceModal
          handleClose={closeModalCancel}
          show={selectedServiceData?.showCancelModal}
          serviceId={selectedServiceData.serviceId}
        />
      ) : null}
      {selectedServiceData?.showDetailsModal ? (
        <ModalServiceData
          show={selectedServiceData.showDetailsModal}
          handleCancelService={handleCancelService(selectedServiceData.serviceId)}
          handleEditService={handleEditService(selectedServiceData.serviceId)}
          serviceId={selectedServiceData.serviceId}
          handleClose={handleCloseModal}
        />
      ) : null}
    </>
  );
}

ModalServiceEvent.propTypes = {
  selectedServiceData: PropTypes.shape({
    showDetailsModal: PropTypes.bool,
    showEditModal: PropTypes.bool,
    showCancelModal: PropTypes.bool,
    serviceId: PropTypes.string,
    showEditSupportModal: PropTypes.bool,
    serviceStatus: PropTypes.number,
  }),
  handleEditService: PropTypes.func,
  onHanldeCloseModalEdit: PropTypes.func,
  handleCancelService: PropTypes.func,
  closeModalCancel: PropTypes.func,
  handleCloseModal: PropTypes.func,
}